export enum ETheme {
    default = 'default',
    inverted = 'inverted',
    LOCALSTORAGE_NAME = 'theme',
}

export type TTheme = ETheme;